export const integrationOptions = [
    {value: "MULTIPLE_LANE_TXT", label: "Múltiplas câmeras - TXT+JPG (Digifort)"},
    {value: "MULTIPLE_LANE_TXT_IMAGES", label: "Múltiplas câmeras - TXT+JPG - V1 (Padrão Sentry)"},
    {value: "MULTIPLE_LANE", label: "Múltiplas câmeras - JPG"},
    {value: "SINGLE_LANE_IMG", label: "Sentry câmera única - JPG"},
    {value: "ROTAOESTE", label: "Rota Oeste"},
    {value: "DAHUA", label: "Dahua"},
    {value: "PUMATRONIX600", label: "Pumatronix 600"},
];

export const translateError = (message, username) => {
    switch (message) {
        case "username.already.registered":
            return `${username} já está sendo utilizado.`;
        case "missing.username":
            return "O campo usuário é obrigatório.";
        case "missing.integration":
            return "O campo integração é obrigatório.";
        case "missing.password":
            return "O campo senha é obrigatório.";
        case "ftpUser.has.lane":
            return "Usuário FTP possui câmera(s) associada(s).";
        default:
            return "Não foi possível salvar.";
    }
};
